<template>
  <div ref="timeline_wrapper" class="w-100">
    <div :id="id" ref="chart" v-on:resize="resizeTimeline()"></div>
    <!--div :ref="id+'-tooltip'" class="timeline-tooltip" v-bind:style="tooltipStyle">Test</div-->
  </div>
</template>

<script>
import * as d3 from "d3v4";
import "@/components/d3-timeline.js"

export default {
  name: 'TimeLine',
  data () {
    return {
      id: 'timeline-0',
      svg: null,
      tooltipStyle: { visibility: 'hidden' },
      chart: null
    }
  },
  props: {
    items: Array,
    beginning: 0,
    ending: 0
  },
  created: function() {
    this.id = 'timeline-'+this._uid
  },
  mounted: function() {
    this.renderChart()
  },
  watch: {
    items: {
      immediate: true,
      handler (val, oldVal) {

        if(this.svg != null) {
          this.svg.remove()

          //this.svg = d3.select("#"+this.id).append("svg")
          //this.svg.attr("width", this.$refs.timeline_wrapper.clientWidth).attr("height", (this.items === undefined ? 0 : this.items.length * 25) + 50)
          this.renderChart()
          //this.svg.datum(this.items).call(this.chart)
        }
      }
    }
  },
  methods: {
    milisToHours(sec) {
      sec = sec / 1000
      var hours = Math.floor(sec / 3600)
      var minutes = Math.floor((sec - (hours * 3600)) / 60)
      var seconds = Math.floor(sec - (hours * 3600) - (minutes * 60))
      return (hours < 10 ? '0' : '') + hours + ":" + (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds
    },
    renderChart() {
      var startDay = 0
      var that = this
      var element = d3.select("#"+this.id)
      element.empty()
      var div = d3.select("body").append("div").attr("class", "timeline-tooltip")

      this.chart = d3.timeline()
          //.relativeTime()
          .stack()
          .beginning(this.beginning)
          .ending(this.ending)
          .tickFormat({
            format: function(d) { return d3.timeFormat("%H:%M")(d) },
            tickTime: d3.timeHours,
            tickInterval: 1,
            tickSize: 12,
          }).mouseover(function (d, i, datum) {
            div.html('<b>'+datum.label+'</b><br/>Frame: '+(new Date(d.starting_time)).toLocaleTimeString()+' - '+(new Date(d.ending_time)).toLocaleTimeString()+'<br/>Frame duration: '+that.milisToHours(d.ending_time - d.starting_time)+'<br/>Total hours: '+that.milisToHours(datum.duration*1000))
            div.style("top", (d3.event.pageY - (div.node().getBoundingClientRect().height+5)) + "px")
            div.style("left", (d3.event.pageX - (div.node().getBoundingClientRect().width/2)) + "px")
            div.style("opacity", .9)
          })
          .mouseout(function (d, i, datum) {
            div.html('From: ').style("opacity", 0)
          })
          .margin({left:70, right:30, top:0, bottom:0})

        this.svg = element.append("svg")
        this.svg.attr("width", this.$refs.timeline_wrapper.clientWidth).attr("height", (this.items === undefined ? 0 : this.items.length * 25) + 50)
        this.svg.datum(this.items).call(this.chart)
    }
  }
}
</script>

<style>
    .timeline-tooltip {
        background-color: azure;
        padding: 5px;
        display: block;
        position: absolute;
        border-radius: 3px;
    }
</style>
